import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AuthAction, AuthService, AuthState, EXPIRE_SESSION_END, RestoreSession } from "core";
import { EMPTY, from, map, of, switchMap } from "rxjs";
import { FirebaseService } from "../../firebase.service";

@Injectable()
export class AuthEffects {

  store = inject(Store<AuthState>);
  actions$ = inject(Actions<AuthAction>);
  fbServ = inject(FirebaseService);
  internalAuthServ = inject(AuthService);

  tokenExpiry$ = createEffect(() => this.actions$.pipe(
    ofType(EXPIRE_SESSION_END),
    switchMap(() => {
      const user = this.fbServ.user;
      if (user) {
        return from(user.getIdToken()).pipe(
          switchMap(fbToken => this.internalAuthServ.internalSignInWithFirebase(fbToken))
        );
      }
      return EMPTY;
    }),
    map(() => new RestoreSession())
  ));

}